import React from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

import dbanLogo from  "../images/dban-logo.png";
const SidebarLogo = (props) => {
  const { sidebarCollapsed, setSidebarCollapsed } = props;
  return (
    <div className="gx-layout-sider-header" style={{height: '60px', backgroundColor: '#ffff'}}>
      <div className="gx-linebar">
        {!sidebarCollapsed ? (
          <MenuUnfoldOutlined
            className="gx-menu-collapse-btn"
            onClick={() => {
              setSidebarCollapsed(!sidebarCollapsed);
            }}
          />
        ) : (
          <MenuFoldOutlined
            className="gx-menu-collapse-btn"
            onClick={() => {
              setSidebarCollapsed(!sidebarCollapsed);
            }}
          />
        )}
      </div>
      {!sidebarCollapsed && (
        <img
          alt="logo"
          height={30}
          src={dbanLogo}
        />
      )}
    </div>
  );
};

export default SidebarLogo;